export default{
    SET_AUTH_USER (state,payload) {
        state.authUser = payload
        state.userProfile = payload
        state.lang = payload.lang
    },
    SET_AUTH_USER_PROFILE(state,payload) {        
        state.userProfile = payload;
    },
    SET_ME_USER(state,payload) {
        state.meuser = payload
    },
    REMOVE_USER_DATA(state) {
        state.userProfile = {};
    },
    CHANGE_USER_LANG(state,payload) {
        state.lang = payload
    }
    
}